export const getStatusColor = (status: string) => {
  let color = "#FFC107";
  switch (status) {
    case "PENDING":
      color = "#FFC107";
      break;
    case "ACCEPTED":
      color = "#4CAF50";
      break;
    case "APPROVED":
      color = "#4CAF50";
      break;
    case "ACTIVE":
      color = "#4CAF50";
      break;
    case "REJECTED":
      color = "#F44336";
      break;
    case "INPROGRESS":
      color = "#2196F3";
      break;
    case "DELIVERED":
      color = "#009688";
      break;
    case "COMPLETED":
      color = "#9C27B0";
      break;
    case "CREATED":
      color = "#39ed99";
      break;
    case "CLOSED":
      color = "#eb4e1e";
      break;
    case "Farmin NOT Started":
      color = "#1e85eb";
      break;
    case "SIGNED":
      color = "#28e0a6";
      break;
    case "VOID":
      color = "#ff0000";
      break;
    case "REDEEMED":
      color = "#03fc67";
      break;
    case "PARTIALLY REDEEMED":
      color = "#03fcf4";
      break;
    case "EXPIRED":
      color = "#ff0";
      break;
    case "VOID":
      color = "#fc0303";
      break;
    case "ISSUED":
      color = "#00FF00";
      break;
    case "PAID":
      color = "#03fc67";
      break;
    default:
      color = "#FFC107";
      break;
  }

  return color;
};
